<template>
    <div class="lg:flex lg:justify-center gap-4">

        <div class="bg-greyStandard standard w-full lg:w-1/2">
            <div class="px-8 py-12 whitespace-pre-wrap">
                <h2 class="text-center mb-8 header">{{ standardDivHeader }}</h2>
                <h3 v-if="standardDivSubheader.length"
                    class=" h6 mb-6 lg:mb-8 uppercase blurb text-offBlack">{{ standardDivSubheader }}</h3>
                <div v-html="standardDivBlurb" class="wysiwyg-block"
                     v-if="standardDivBlurb.length"></div>
                <div class="btn-wrap mt-12 flex justify-center">
                    <button class="button primary" v-on:click="startCustomiser('standard')">Start customising</button>
                </div>
            </div>
        </div>

        <div class="bg-greyLandmark landmark-config w-full lg:w-1/2 mt-8 lg:mt-0" v-if="landmarkavailable">
            <div class="px-8 py-12 whitespace-pre-wrap">
                <h2 class="text-center mb-8 header">{{ landmarkDivHeader }}</h2>
                <h3 v-if="landmarkDivSubheader.length"
                    class=" h6 mb-6 lg:mb-8 uppercase blurb">{{ landmarkDivSubheader }}</h3>
                <div v-html="landmarkDivBlurb" class="wysiwyg-block"
                     v-if="landmarkDivBlurb.length"></div>
                <div class="btn-wrap mt-12 flex justify-center align-middle gap-6">
                    <button class="button primary" @click="startCustomiser('landmark')">Start customising</button>
                    <button class="button-alternate text-gold" @click="$emit('enquire', 'landmark')">Enquire</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    props: {
        landmarkavailable: {
            required: true
        },
        standardcustomisation: {
            required: true
        },
        landmarkcustomisation: {
            required: true
        },
    },
    computed: {
        standardDivHeader() {
            return this.standardcustomisation[0]
        },
        standardDivSubheader() {
            return this.standardcustomisation[1]
        },
        standardDivBlurb() {
            return this.standardcustomisation[2]
        },
        landmarkDivHeader() {
            return this.landmarkcustomisation[0]
        },
        landmarkDivSubheader() {
            return this.landmarkcustomisation[1]
        },
        landmarkDivBlurb() {
            return this.landmarkcustomisation[2]
        }
    },
    name: "ConfiguratorPicker",
    emits: ["startCustomiser"],
    methods: {
        startCustomiser(type) {
            this.$emit("start", type);
        }
    },
}
</script>